import {
    IndigoStreamRequest,
    RequestBatchSanitizer,
} from 'communication/streaming/SockJSStreamingService';
import GetOrderColumnsRequest from 'communication/types/order/GetOrderColumnsRequest';

export const ordersRequestBatchSanitizer: RequestBatchSanitizer = (
    requests: IndigoStreamRequest[]
) => {
    if (requests.length < 1) {
        throw new Error('At least one request expected');
    }
    const ret: IndigoStreamRequest[] = [];
    let startRequest: IndigoStreamRequest | undefined;

    for (const req of requests) {
        if (
            req.indigo2AsyncDestination.toString() === 'stopOrderColumnsStream'
        ) {
            // Discard the start request, add the stop
            startRequest = undefined;
            ret.push(req);
            continue;
        }

        if (!startRequest) {
            startRequest = req;
        } else {
            combine(startRequest.payload, req.payload);
        }
    }

    if (startRequest) {
        ret.push(startRequest);
    }

    return ret;
};

function combine(prev: GetOrderColumnsRequest, next: GetOrderColumnsRequest) {
    for (const addCol of next.addCols) {
        if (!prev.addCols.find((c) => c === addCol)) {
            prev.addCols.push(addCol);
        }
        prev.delCols = prev.delCols.filter((c) => c !== addCol);
    }
    for (const delCol of next.delCols) {
        if (!prev.delCols.find((c) => c === delCol)) {
            prev.delCols.push(delCol);
        }
        prev.addCols = prev.addCols.filter((c) => c !== delCol);
    }

    if (next.orderIds) {
        prev.orderIds = next.orderIds;
    }
}
